/* 1.0 - Abstracts */
@import '../../../scss/abstracts/variables';

/* 2.0 - Base */
@import '../../../scss/base/reset';
@import '../../../scss/base/fonts';

/* 3.0 - Components */
@import '../../../scss/components/buttons';

/**
  Global style for a modal
**/

.ike-modal-wrapper {
  display: none;
  height: 100%;
  left: 0;
  overflow: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 97;

  &.visible {
    display: block;
  }
}

.ike-modal-background {
  background-color: black;
  height: 100%;
  left: 0;
  opacity: 0.8;
  position: fixed;
  top: 0;
  transform: scale(1.1);
  width: 100%;
  z-index: 98;
}

.ike-modal {
  animation: animatetop 0.3s !important;
  background-color: $white;
  background-color: var(--white);
  border-radius: 10px;
  font-size: 13px;
  left: 50%;
  min-width: 300px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;

  &.EMBEDED {
    max-width: 650px;
    width: 95%;
  }
}

.is-profile > .ike-modal {
  transform: translate(-50%, calc(-50% + 45px));
  max-height: calc(90vh - 90px);
}

.is-profile > .ike-modal,
.is-profile > .ike-modal > .ike-modal-content {
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@keyframes animatetop {
  from {
    opacity: 0;
    top: 45%;
  }

  to {
    opacity: 1;
    top: 50%;
  }
}

.ike-modal-content {
  border-radius: 10px;
  padding: 30px;

  .croppr-container {
    text-align: center;
  }
}

.ike-modal-buttons {
  padding: 5px 10px 10px 10px;
  text-align: right;
}

.ike-modal-buttons button {
  cursor: pointer;
  font-size: inherit;
  line-height: 20px;
  margin-left: 10px;
  min-width: 80px;
  padding: 3px;
}

@media all and (max-width: 768px) {
  .ike-modal-content {
    padding: 20px;
  }

  .ike-modal {
    min-width: 90%;
    width: 90%;
  }
}
